// Killer cages: a dashed outline inset from the cell borders, the sum top-left on a patch.
// Cosmetic cages from imports are drawn with the same component.
import type { PuzzleDoc, Rc } from '@zinc/shared';
import { CornerLabel } from './CornerLabel';
import { cageOutline, num, ofType, rcList, styleOf, text, topLeft } from './geom';
import { CAGE } from './style';

export function Cage({
  cells,
  label,
  color = CAGE.color,
  width = CAGE.width,
  type,
}: {
  cells: Rc[];
  label?: string | null;
  color?: string;
  width?: number;
  type?: string;
}) {
  const corner = topLeft(cells);
  if (!corner) return null;
  return (
    <g data-constraint={type}>
      <path
        d={cageOutline(cells, CAGE.inset)}
        fill="none"
        stroke={color}
        strokeWidth={width}
        strokeDasharray={CAGE.dash}
      />
      {label ? <CornerLabel cell={corner} text={label} /> : null}
    </g>
  );
}

export function Killers({ doc }: { doc: PuzzleDoc }) {
  return (
    <g>
      {/* A cage whose total counts only its unshaded cells (Pack 6) is drawn as a cage. */}
      {ofType(doc, 'killer', 'unshaded-sum').map((e, i) => {
        const { color, width } = styleOf(e, CAGE);
        const sum = num(e, 'sum');
        const label = text(e, 'label') ?? (sum === null ? null : String(sum));
        return (
          <Cage key={i} type={e.type} cells={rcList(e)} label={label} color={color} width={width} />
        );
      })}
    </g>
  );
}
